// Pure email parsing/validation for the invite-user chip input. No React or
// state: the caller owns the selected-emails list and applies the result. Kept
// framework-free so it's unit-testable and reusable across apps.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Whether a string is a well-formed email (trimmed). */
export const isValidEmail = (email) => EMAIL_RE.test((email || "").trim());

/**
 * Split raw input on comma / semicolon / whitespace, validate each token, and
 * skip emails already selected. Returns fresh chip objects for the valid,
 * not-yet-selected emails plus the invalid tokens (which the caller keeps in the
 * input box). Dedup is only against `existingEmails` — repeats within one input
 * are not collapsed, matching the original modal behavior.
 *
 * @param {string} inputValue
 * @param {{ email: string }[]} existingEmails
 * @returns {{ validEmails: { name: string, email: string }[], invalidEmails: string[] }}
 */
export const parseEmailInput = (inputValue, existingEmails = []) => {
  const parts = (inputValue || "")
    .split(/[,;\s\n\t]+/)
    .map((email) => email.trim())
    .filter((email) => email.length > 0);

  const validEmails = [];
  const invalidEmails = [];

  parts.forEach((email) => {
    if (isValidEmail(email)) {
      if (!existingEmails.find((selected) => selected.email === email)) {
        validEmails.push({ name: "", email });
      }
    } else {
      invalidEmails.push(email);
    }
  });

  return { validEmails, invalidEmails };
};
